import React from 'react';
import { Descriptions, Card, Button } from 'antd';

import { ArrowLeftOutlined } from '@ant-design/icons';
import { Navigation } from '@constants/Navigation';
import { ApiUserResponse } from '@openapi';
import { useHistory, useParams } from 'react-router-dom';
import api from '@services/api';

const InfoUserModal = () => {
  const { id } = useParams<{ id: string }>();
  const [apiUser, setApiUser] = React.useState<ApiUserResponse>();
  const history = useHistory();

  const onClose = () => {
    history.push(Navigation.ApiUsers);
  };

  React.useEffect(() => {
    api.administration.getApiUserById(id).then(setApiUser);
  }, []);

  return (
    <Card
      title="ApiUser info"
      extra={
        <Button icon={<ArrowLeftOutlined />} type="default" onClick={onClose}>
          Back to Api Users Page
        </Button>
      }
    >
      <Descriptions labelStyle={{ fontWeight: '500', fontSize: '16px' }} layout="horizontal" column={1} bordered>
        <Descriptions.Item label="Id">{apiUser?.id}</Descriptions.Item>
        <Descriptions.Item label="API user key">{apiUser?.apiKey}</Descriptions.Item>
        <Descriptions.Item label="Description">{apiUser?.description}</Descriptions.Item>
        <Descriptions.Item label="Role">{apiUser?.roles?.join(', ')}</Descriptions.Item>
        <Descriptions.Item label="Perimeter">{apiUser?.etc?.perimeterNames?.join(', ')}</Descriptions.Item>
        <Descriptions.Item label="Creation date">{apiUser?.createdAt?.toLocaleString()}</Descriptions.Item>
        <Descriptions.Item label="Last modification">{apiUser?.modifiedAt?.toLocaleString()}</Descriptions.Item>
        <Descriptions.Item label="Last connection">{apiUser?.lastAuthenticatedAt?.toLocaleString()}</Descriptions.Item>
        <Descriptions.Item label="Create by">{apiUser?.createdBy}</Descriptions.Item>
        <Descriptions.Item label="Modified by">{apiUser?.modifiedBy}</Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default React.memo(InfoUserModal);
